module.exports = __webpack_public_path__ + "img/asd.d482c287.png";